var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYtCorner = function SvgYtCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 82 82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yt-corner_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.536 45.053 60.903-27.116L93.42 60.57 32.517 87.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m50.996 60.758 9.84-12.317-15.84-1.158 6 13.475Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M57.307 7.321 17.11 25.218a17.925 17.925 0 0 0-9.123 23.765l17.897 40.196A17.925 17.925 0 0 0 49.65 98.3l40.196-17.896a17.925 17.925 0 0 0 9.122-23.765L81.072 16.444A17.925 17.925 0 0 0 57.307 7.32Zm20.305 36.387c1.729 3.883 3 7.969 3 7.969s.968 3.4.309 5.61c-1.014 2.64-3.07 3.555-3.881 4.19-6.42 3.406-16.469 7.88-16.469 7.88s-12.333 5.49-16.419 6.763c-1.243.28-3.527 1.297-6.168.283-1.98-.76-3.962-3.983-3.962-3.983s-2.186-3.679-3.914-7.561l-1.627-3.655c-1.729-3.882-3-7.968-3-7.968s-.739-3.503.021-5.483c1.014-2.64 3.07-3.556 3.881-4.19 6.42-3.407 16.469-7.88 16.469-7.88s10.049-4.475 16.876-6.967c.913-.407 3.07-1.093 5.71-.08 1.981.76 3.963 3.983 3.963 3.983s2.186 3.68 3.914 7.562l1.526 3.426-.229.101Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yt-corner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 32.54 73.751 0l32.539 73.084-73.084 32.539z"
  })))));
};
export default SvgYtCorner;